import { render } from "./SelectedFiltersCount.vue?vue&type=template&id=4c0c127a&scoped=true"
import script from "./SelectedFiltersCount.vue?vue&type=script&lang=js"
export * from "./SelectedFiltersCount.vue?vue&type=script&lang=js"

import "./SelectedFiltersCount.vue?vue&type=style&index=0&id=4c0c127a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0c127a"]])

export default __exports__